<template>
  <!-- 用户管理 -->
  <div class="userManagement">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input
          v-model.trim="query.query"
          placeholder="请输入用户名/姓名/证件号码"
          style="width: 240px; margin-right: 10px"
          @keyup.enter.native="freshLoad"
          @clear="
            query.query = '';
            tableLoad();
          "
          clearable
          suffix-icon="el-icon-search"
        ></el-input>
        <Debounce>
          <el-button style="margin-right: 10px" size="small" @click="freshLoad">查询</el-button>
        </Debounce>
        <!-- <el-radio-group @change="freshLoad" v-model="query.roleId" size="small">
          <el-radio-button v-for="item in roleSelectList" :key="item.value" :label="item.value"
            :value="item.value">{{ item.label }}</el-radio-button>
        </el-radio-group> -->
        <el-select v-model="query.roleId" @change="freshLoad" size="small" placeholder="请选择角色">
          <!-- 默认选项 -->
          <el-option
            v-for="item in roleSelectList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <FileOperatDropdown
        @reLoad="freshLoad"
        style="margin: 0px 10px"
        :uploadUrl="'user/importUser'"
        :downloadUrl="'user/download'"
        :butText="['下载模板', '导入用户']"
      />
      <el-button type="primary" size="small" @click="operatInfo(1)">添加</el-button>
      <el-button type="danger" size="small" @click="operatInfo(0)">删除</el-button>
    </el-row>
    <el-table
      :data="tableList"
      tooltip-effect="dark"
      border
      ref="elTable"
      style="width: 100%"
      :header-cell-style="$store.getters.getTableHeadStyle"
      v-loading="tableIsLoad"
      element-loading-text="加载中"
      @selection-change="handleSelectionChange"
      :height="$store.getters.getTableHeight"
    >
      <el-table-column type="selection" align="center" width="50"></el-table-column>
      <el-table-column prop="userName" label="用户名" width="150" align="center"></el-table-column>
      <el-table-column prop="name" label="姓名" width="200" align="center"></el-table-column>
      <el-table-column
        prop="sex_dictText"
        label="性别"
        width="100"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="idNumber"
        label="证件号码"
        width="200"
        align="center"
      ></el-table-column>
      <el-table-column prop="roleName" label="所属角色" align="center">
        <template slot-scope="scope">
          {{ scope.row.roleNameList.join(',') }}
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="联系电话" width="200" align="center"></el-table-column>
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="tableContentUpdateBut"
            size="small"
            @click="operatInfo(2, scope.row)"
            >修改</el-button
          >
          <template>
            <span style="margin: 0px 5px">|</span>
            <el-button type="text" size="small" @click="operatInfo(3, scope.row)"
              >密码初始化</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      :total="query.total"
      :page.sync="query.pageNum"
      :limit.sync="query.pageSize"
      class="pagination-content"
      @pagination="tableLoad"
    />
    <el-dialog
      custom-class="dailogComponents"
      :title="visibleType == 1 ? '添加' : '修改'"
      :visible.sync="visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      v-if="visible"
      width="400px"
    >
      <div class="dialogBox">
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p><span style="color: red">*</span>用户名:</p>
          </el-col>
          <el-col :offset="1">
            <el-input
              v-model="visibleObj.userName"
              placeholder="请输入(大小写字母、数字1-25位)"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p><span style="color: red">*</span>姓名:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.name" placeholder="请输入内容"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p><span style="color: red">*</span>性别:</p>
          </el-col>
          <el-col :offset="1">
            <el-radio-group v-model="visibleObj.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p>证件号码:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.idNumber" placeholder="请输入内容"></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p><span style="color: red">*</span>所属角色:</p>
          </el-col>
          <el-col :offset="1">
            <el-select
              v-model="visibleObj.roleIdList"
              filterable
              multiple
              style="width: 100%"
              placeholder="请选择"
            >
              <el-option
                v-for="item in roleList"
                :key="item.value + ''"
                :disabled="item.disabled"
                :label="item.label"
                :value="item.value + ''"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex" class="dialogTitle" justify="space-between">
          <el-col :span="6">
            <p><span style="color: red">*</span>联系电话:</p>
          </el-col>
          <el-col :offset="1">
            <el-input
              v-model="visibleObj.mobile"
              placeholder="请输入10-15位数字的手机号！"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-col :span="7">
            <el-button size="medium" @click="visible = false">取消</el-button>
          </el-col>
          <el-col :span="4">
            <el-button size="medium" type="primary" @click="submit">确认</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FileOperatDropdown from '@/views/admin/components/FileOperatDropdown';

export default {
  components: {
    FileOperatDropdown,
  },
  data() {
    return {
      tableList: [],
      tableSelectList: [],
      tableIsLoad: true,
      roleList: [],
      roleSelectList: [],
      visible: false,
      visibleType: 0, //删除
      visibleObj: {
        mobile: '', //手机号
        name: '', //姓名
        sex: 1, //性别
        userName: '', //用户名
        roleIdList: [], //角色list
      },
      query: {
        query: '',
        roleId: null,
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
      },
      rolesIds: ['1', '2', '3', '4', '5', '6', '8', '9'],
      msgList: [
        '是否删除所选内容？',
        '该用户已被设为省级管理员，删除后无法恢复，该省份需重新添加负责人，是否删除？',
        '该用户已被设为市级管理员，删除后无法恢复，该考点需重新添加负责人，是否删除？',
        '该用户已被设为考点管理员，删除后无法恢复，该报名点需重新添加负责人，是否删除？',
        '该评委已打分，删除后评分信息无法恢复 ，是否继续删除？',
        '该考生已报名，删除后该考生注册、报名、考试信息将无法恢复，是否继续删除？',
        '没有视频播放员无法播放考生视频，是否继续删除？',
      ],
    };
  },
  mounted() {
    this.getAllRole();
    // this.tableLoad();
  },
  methods: {
    tableLoad() {
      this.tableIsLoad = true;
      this.$axios.post('/user/list', this.query).then((res) => {
        console.log(res);
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    passButIsShow(list) {
      let isShow = false;
      list.map((item) => {
        console.log('item', item);
        if (this.rolesIds.some((child) => child == item)) {
          isShow = true;
        }
        return item;
      });
      return isShow;
    },
    getAllRole() {
      this.$axios.get('role/user/add/select').then((res) => {
        console.log(res);
        let data = res.data.data.map((item) => {
          item.disabled = false;
          return item;
        });
        data.push({ label: '考生', value: '6', disabled: true });
        data.push({ label: '视频播放员', value: '7', disabled: true });
        this.roleList = data;
      });
      this.$axios.get('user/listSelect').then((res) => {
        this.roleSelectList = res.data.data;
        this.query.roleId = this.roleSelectList[0].value;
        this.tableLoad();
      }).catch((err) => {
        this.tableLoad();
      })
    },
    handleSelectionChange(val) {
      this.tableSelectList = val;
    },
    operatInfo(type, row) {
      this.visibleType = type;
      this.visibleObj = {
        mobile: '', //手机号
        name: '', //姓名
        sex: 1, //性别
        userName: '', //用户名
        roleIdList: [], //角色list
      };
      if (type === 0) {
        //删除
        if (this.tableSelectList.length === 0) {
          this.$message({
            type: 'warning',
            message: '请选择数据进行删除!',
            duration: 1000,
          });
          return;
        }
        // 给一个默认弹框内容
        let msg = '';
        let submitIdList = this.tableSelectList.map((item) => {
          if (this.query.roleId == 7) {
            // 当前角色为视频播放员时做视频管理员的提示
            msg = this.msgList[6];
          } else if (item.linkProvince > 0) {
            // 当前关联省级管理员数时，提示已关联是否删除
            msg = this.msgList[1];
          } else if (item.linkExamSite > 0) {
            // 当前关联市级管理员数时，提示已关联是否删除
            msg = this.msgList[2];
          } else if (item.linkRrgSite > 0) {
            // 当前关联考点管理员数时，提示已关联是否删除
            msg = this.msgList[3];
          } else if (item.linkScore > 0) {
            // 当前关联评委数时，提示已关联是否删除
            msg = this.msgList[4];
          } else if (item.linkRegister > 0) {
            // 当前关联考生数时，提示已关联是否删除
            msg = this.msgList[5];
          } else {
            msg = this.msgList[0];
          }
          return item.userId;
        });
        //删除
        this.$dailog({
          title: '删除',
          context: msg,
          callbackFun: () => {
            this.$axios
              .delete('/user', {
                data: submitIdList,
              })
              .then((res) => {
                this.$message({
                  type: 'success',
                  message: '操作成功!',
                  duration: 1000,
                });
                this.tableLoad();
              });
          },
        });
      } else if (type === 1) {
        //添加
        this.visible = true;
      } else if (type == 3) {
        this.$dailog({
          title: '提示',
          context: '确认将密码修改为当前联系电话？',
          callbackFun: () => {
            this.$axios
              .post('user/init', {
                mobile: row.mobile,
                userId: row.userId,
              })
              .then((res) => {
                this.$message({
                  type: 'success',
                  message: '初始化成功!',
                  duration: 1000,
                });
                this.tableLoad();
              });
          },
        });
      } else {
        //修改
        console.log(row);
        this.visible = true;
        this.visibleObj = JSON.parse(JSON.stringify(row));
      }
    },
    freshLoad() {
      this.query.pageNum = 1;
      this.tableLoad();
    },
    submit() {
      let { userName, name, mobile, userId, roleIdList } = this.visibleObj;
      let reg = /^([A-Za-z\d_@·-]){1,25}$/i;
      let numberTest = /^\d{10,15}$/;
      if (userName === '' || name === '' || mobile === '' || roleIdList.length === 0) {
        this.$message({
          type: 'warning',
          message: '必填项不能为空!',
          duration: 1000,
        });
        return;
      }
      if (!reg.test(userName)) {
        this.$message({
          type: 'warning',
          message: '用户名请输入(1-25位用户名)!',
          duration: 1000,
        });
        return;
      }
      if (!numberTest.test(mobile)) {
        this.$message({
          type: 'warning',
          message: '请输入10-15位数字的手机号！',
          duration: 1000,
        });
        return;
      }
      let subType = this.visibleType === 1 ? 'post' : 'put';
      let url = this.visibleType === 1 ? '/user' : '/user/' + userId;
      this.$axios({
        method: subType,
        url: url,
        data: this.visibleObj,
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '保存成功!',
          duration: 1000,
        });
        this.visible = false;
        this.tableLoad();
      });
    },
  },
};
</script>
